import React from 'react';
import { SearchX, Filter, AlertCircle } from 'lucide-react';

/**
 * ZeroResultsMessage - Displays informative message when no results found
 * Per Filter Doctrine: Zero-result states must identify which filter(s) caused collapse
 */
const ZeroResultsMessage = ({ metadata, onClearFilters, fundingType = 'scholarship' }) => {
  const { total, zeroResultCause, activeFilters } = metadata;
  
  // Determine the label based on funding type
  const itemLabel = fundingType === 'grant' ? 'grant' : 'scholarship';
  const itemLabelPlural = fundingType === 'grant' ? 'grants' : 'scholarships';
  
  // Map filter keys to human-readable names
  const filterLabels = {
    amount: 'Award Amount',
    deadline: 'Deadline',
    educationLevel: 'Education Level',
    renewable: 'Renewable',
    search: 'Search Query',
  };
  
  const causeLabel = zeroResultCause?.filter 
    ? filterLabels[zeroResultCause.filter] || zeroResultCause.filter
    : null;
  
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-8 text-center">
      <div className="flex justify-center mb-4">
        <div className="p-3 bg-amber-100 rounded-full">
          <SearchX size={32} className="text-amber-600" />
        </div>
      </div>
      
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        No {itemLabelPlural} match your current filters
      </h3>
      
      {zeroResultCause && (
        <div className="mb-4 p-3 bg-amber-100/50 rounded-lg inline-flex items-center gap-2">
          <AlertCircle size={16} className="text-amber-600" />
          <span className="text-sm text-amber-800">
            The <strong>{causeLabel}</strong> filter excluded {zeroResultCause.excluded} {zeroResultCause.excluded !== 1 ? itemLabelPlural : itemLabel}
          </span>
        </div>
      )}
      
      <p className="text-gray-600 mb-4">
        {total > 0 ? (
          <>
            There are <strong>{total}</strong> {itemLabelPlural} available. 
            Try adjusting or clearing your filters to see more results.
          </>
        ) : (
          `No ${itemLabelPlural} are currently available.`
        )}
      </p>
      
      {activeFilters && activeFilters.length > 0 && (
        <div className="space-y-3">
          <div className="text-sm text-gray-500">
            Active filters: {activeFilters.map(f => filterLabels[f] || f).join(', ')}
          </div>
          
          <button
            onClick={onClearFilters}
            className="inline-flex items-center gap-2 px-4 py-2 bg-[#1a5d3a] text-white rounded-md hover:bg-[#154a2e] transition-colors"
          >
            <Filter size={16} />
            Clear all filters
          </button>
        </div>
      )}
    </div>
  );
};

export default ZeroResultsMessage;
